import BookIcon from '@material-ui/icons/Book'
import StockReviewShow from './StockReviewShow'
import StockReviewList from './StockReviewList'

export default {
    list: StockReviewList,
    show: StockReviewShow,
    icon: BookIcon,
}
